import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from './ui/Card';
import { Database, Key, GitMerge, CalendarClock, Copy } from 'lucide-react';
export function ModulesSection() {
  const modules = [{
    icon: Database,
    title: 'Módulo 1: El Ecosistema de 3 Capas',
    desc: 'Cómo unir las herramientas líderes del mercado sin ser programador. Entiende la base sólida.'
  }, {
    icon: Key,
    title: 'Módulo 2: Configuración API Oficial',
    desc: 'Evita bloqueos y asegúrate de que tus mensajes lleguen siempre a la bandeja de entrada.'
  }, {
    icon: GitMerge,
    title: 'Módulo 3: El Diseñador de Flujos',
    desc: "Guía visual Drag & Drop para 'dibujar' el camino que seguirá tu cliente desde que agenda."
  }, {
    icon: CalendarClock,
    title: 'Módulo 4: Reagendamiento Maestro',
    desc: 'La lógica exacta para que, si un cliente cancela, el bot le venda una nueva fecha de inmediato.'
  }, {
    icon: Copy,
    title: "Módulo 5: Scripts 'Copy-Paste'",
    desc: 'Listos para servicios de Techos, Solar, Plomería, Dentistas y más. Solo copia y pega.'
  }];
  return <section className="py-24 bg-[#0f1629]" data-id="element-73">
      <div className="container mx-auto px-4" data-id="element-74">
        <div className="text-center mb-16" data-id="element-75">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-76">
            Dentro de este PDF y su Guía Técnica encontrarás:
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto" data-id="element-77">
            Todo lo que necesitas para automatizar tu negocio, dividido en
            módulos prácticos y directos.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-78">
          {modules.map((module, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-79">
              <Card className="h-full hover:border-[#25D366]/50 transition-colors duration-300 group" data-id="element-80">
                <CardHeader data-id="element-81">
                  <div className="w-12 h-12 rounded-lg bg-slate-800 flex items-center justify-center mb-4 group-hover:bg-[#25D366] transition-colors duration-300" data-id="element-82">
                    <module.icon className="h-6 w-6 text-[#25D366] group-hover:text-white transition-colors duration-300" data-id="element-83" />
                  </div>
                  <CardTitle className="text-xl text-white group-hover:text-[#25D366] transition-colors" data-id="element-84">
                    {module.title}
                  </CardTitle>
                </CardHeader>
                <CardContent data-id="element-85">
                  <p className="text-slate-400" data-id="element-86">{module.desc}</p>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}